import React from 'react';
import { Button, Modal } from '../../../../components';

type ConfirmationModalProps = {
  serviceName: string;
  incomingOperation: string;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  serviceName,
  incomingOperation,
  onClose,
  onConfirm,
  open,
}: ConfirmationModalProps): JSX.Element => {
  return (
    <Modal open={open} title="Are you sure?" onClose={onClose}>
      <>
        Are you sure you would like to turn{' '}
        <span className="confirmation__org">{serviceName}</span>{' '}
        {incomingOperation}? This would turn it{' '}
        <span className="confirmation__operation">{incomingOperation}</span> for
        all the users in your organization
        <Button
          onClick={onClose}
          className="confirmation__btn"
          variant="common"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          className="confirmation__btn"
          variant="text"
        >{`Turn ${incomingOperation}`}</Button>
      </>
    </Modal>
  );
};
